document.addEventListener('turbolinks:load', () => {
    // Iframe
    const pwaPreviewIframe= document.getElementById('pwaPreviewIframe')
    let pwaAddress
    if (pwaPreviewIframe !== null) {
        pwaAddress = pwaPreviewIframe.dataset.byodAddress
    }

    // buttons
    const pwaOpenSafetyNoticesButton = document.getElementById('pwaOpenSafetyNoticesButton')
    const pwaOpenWelcomeButton = document.getElementById('pwaOpenWelcomeButton')
    const pwaOpenOnboardingButton = document.getElementById('pwaOpenOnboardingButton')
    const pwaOpenToursButton = document.getElementById('pwaOpenToursButton')

    // element to check if deployment or preview update is running
    const deploymentOngoingConfirmDiv = document.getElementById('deploymentOngoingConfirmDiv')

    //add click Listener to button to change preview
    if (pwaPreviewIframe !== null && pwaOpenSafetyNoticesButton !== null && pwaAddress !== null) {
        pwaOpenSafetyNoticesButton.addEventListener('click', function () {
            pwaPreviewIframe.src = `${pwaAddress}/sicherheitshinweise/preview`
        })
    }

    if (pwaPreviewIframe !== null && pwaOpenWelcomeButton !== null && pwaAddress !== null) {
        pwaOpenWelcomeButton.addEventListener('click', function () {
            const orgaId = pwaPreviewIframe.dataset.byodOrgaId
            const orgaKey = pwaPreviewIframe.dataset.byodOrgaKey
            pwaPreviewIframe.src = `${pwaAddress}/organization/${orgaId}/key/${orgaKey}`
        })
    }

    if (pwaPreviewIframe !== null && pwaOpenOnboardingButton !== null && pwaAddress !== null) {
        pwaOpenOnboardingButton.addEventListener('click', function () {
            pwaPreviewIframe.src = `${pwaAddress}/schriftgroesse`
        })
    }

    if (pwaPreviewIframe !== null && pwaOpenToursButton !== null && pwaAddress !== null) {
        pwaOpenToursButton.addEventListener('click', function () {
            pwaPreviewIframe.src = `${pwaAddress}/touren`
        })
    }

    // Periodically check deployment status every 3 seconds,
    // as long as the deploymentOngoingConfirmDiv is present in the DOM (only while a deployment is ongoing).
    // if the deployment is no longer active the ajax request will trigger a page reload
    // If the element is removed, stop the interval.
    if (deploymentOngoingConfirmDiv !== null) {
        const intervalId = setInterval(() => {

            const currentDeploymentOngoingConfirmDiv = document.getElementById('deploymentOngoingConfirmDiv')
            if (currentDeploymentOngoingConfirmDiv === null) {
                clearInterval(intervalId);
            } else {
                // ask
                $.rails.ajax({
                    url: `/byod/deployment_status`,
                    type: "get",
                    data: "",
                    dataType: "script"
                })
            }
        }, 3000);
    }

});